"use client";

import { useSyncExternalStore } from "react";

const subscribe = () => () => undefined;

export function useMounted() {
  return useSyncExternalStore(
    subscribe,
    () => true,
    () => false
  );
}
